import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://www.linkedin.com/in/joshualaikowski/'
      className='link footer__link'
      target='_blank'
      rel='noreferrer'
    >
      Joshua Laikowski
    </a>
  </footer>
)

export default Footer
